import {Hydra} from '../generic/hydra';

import {DepartementInterface} from './Departement';
import {CountryInterface} from './Country';
import {Adresse as AdresseBaseInterface} from '../../interface/api/Adresse';

export type AdresseInterface = AdresseBaseInterface;

export class Adresse extends Hydra implements AdresseInterface {

    id?: number | null;

    adresseComplete?: string | null;

    numEtVoie?: string | null;

    codePostal?: string | null;

    cedex?: string | null;

    ville?: string | null;

    departement?: DepartementInterface | string | null;

    /* Country, sous forme d'IRI ou d'objet
     */
    pays?: CountryInterface | string | null;

    lat?: number | null;

    lon?: number | null;


    constructor(options: AdresseInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
